














import { Component, mixins } from 'nuxt-property-decorator'

import PageTransitionMixin from '@/mixins/transitions/page'

@Component
export default class PageLegal extends mixins(PageTransitionMixin) {
  head() {
    const title = this.$t('legal.meta_title')
    const description = this.$t('legal.meta_description')

    return {
      title,
      meta: [
        { hid: 'description', name: 'description', content: description },
        // Open Graph
        { hid: 'og:title', property: 'og:title', content: title },
        { hid: 'og:description', property: 'og:description', content: description },
        // Twitter Card
        { hid: 'twitter:title', name: 'twitter:title', content: title },
        { hid: 'twitter:description', name: 'twitter:description', content: description }
      ]
    }
  }
}
